const useEnvVersion = (version) => process.env.REACT_APP_ENV_VERSION === String(version);

export default useEnvVersion;
